"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCompany = exports.getCompanyById = exports.getCompanies = exports.defaultCompanyData = exports.createCompany = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultCompanyData = exports.defaultCompanyData = {
  id: undefined,
  enabled: true,
  name: '',
  logo: '',
  address: '',
  gstNumber: '',
  panNumber: '',
  companyCode: '',
  stateId: null,
  emailAddress: '',
  landlineNumber: '',
  mobileNumbers: [],
  broucherUrl: ''
};
const getCompanies = query => (0, _request.default)({
  url: '/companies',
  method: 'get',
  params: query
});
exports.getCompanies = getCompanies;
const getCompanyById = id => (0, _request.default)({
  url: `/companies/${id}`,
  method: 'get'
});
exports.getCompanyById = getCompanyById;
const createCompany = data => (0, _request.default)({
  url: '/companies',
  method: 'post',
  data
});
exports.createCompany = createCompany;
const updateCompany = (id, data) => (0, _request.default)({
  url: `/companies/${id}`,
  method: 'patch',
  data
});
exports.updateCompany = updateCompany;